import React from 'react';
import DeleteModal from './DeleteModal';

const DispatchContext = React.createContext(undefined);

const initState = {
  shown: false,
  objectName: '',
  title: '',
  subtitle: '',
  warningText: '',
  onDelete: () => {},
  disabled: true,
  errorText: ''
};

function Reducer(state, action) {
  var stateUpdates = {};

  switch (action.action) {
    case 'open':
      stateUpdates = {
        shown: true,
        objectName: action.objectName,
        title: action.title,
        subtitle: action?.subtitle ?? '',
        warningText: action?.warningText ?? '',
        onDelete: action?.onDelete ?? (async () => {})
      };
      break;
    case 'close':
      stateUpdates = {
        shown: false
      };
      break;
    case 'setDisabled':
      const newS = {
        ...state,
        disabled: action.disabled
      };
      return newS;
    case 'error':
      return {
        ...state,
        errorText: action.error
      };
    default:
      throw new Error('No action given');
  }

  var newState = { ...initState, ...stateUpdates };
  return newState;
}

function DeleteModalProvider({ children }) {
  const [state, dispatch] = React.useReducer(Reducer, initState);

  return (
    <DispatchContext.Provider value={dispatch}>
      <DeleteModal
        open={state.shown}
        onClose={() => {
          dispatch({
            action: 'close'
          });
        }}
        onDelete={async () => {
          const { success, error } = await state.onDelete();
          if (success) {
            dispatch({
              action: 'close'
            });
          } else {
            dispatch({
              action: 'error',
              error
            });
          }
        }}
        objectName={state.objectName}
        title={state.title}
        subtitle={state.subtitle}
        warningText={state.warningText}
        disabled={state.disabled}
        error={state.errorText}
        setDisabled={val => {
          dispatch({
            action: 'setDisabled',
            disabled: val
          });
        }}
      />
      {children}
    </DispatchContext.Provider>
  );
}

function useDeleteModalDispatch() {
  const context = React.useContext(DispatchContext);
  if (context === undefined) {
    throw new Error(
      'DeleteModalDispatch must be used with DeleteModalProvider'
    );
  }
  return context;
}

export { DeleteModalProvider, useDeleteModalDispatch };
